module.exports = __webpack_public_path__ + "img/gestoMaosParaBaixo.e7cdfbbc.png";